

























































































































































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
  Area,
  Divider,
} from "vant";
import WeMixin from "@/components/weMixin";
import api from "../../../components/http/api";
import { RegisterInfo } from "./UserApi";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
    [Area.name]: Area,
    [Divider.name]: Divider,
  },
})
export default class RegisterFromCouponKjsm extends mixins(WeMixin) {
  private registerInfo: RegisterInfo = {} as RegisterInfo;
  private buttonActive: boolean = false;
  private isError: boolean = true;
  private isShowError: boolean = false;

  private showOrg: boolean = false;
  private orgList = [
    {
      text: "江苏",
      orgId: "111111",
      children: [
        {
          text: "初始化",
          orgId: "111111",
          children: [{ text: "初始化", orgId: "111111" }],
        },
      ],
    },
  ];

  protected created() {
    this.getOrgList();
    this.checkIsSubscribe();
  }

  protected getOrgList() {
    api.post("/weixinmp/xsyx/myuser/getOrgList", {}).then((res: any) => {
      this.orgList = res.data;
    });
  }

  protected checkIsSubscribe() {
    api.post("/weixinmp/xsyx/myuser/checkIsSubscribe", {}).then((res: any) => {
      if (!res.data) {
        this.buttonActive = true;
        this.isError = false;
        this.isShowError = true;
        // this.$toast({
        //   message:
        //     "你尚未注册苏邮惠会员，请先退出后登陆“江苏邮政微金融”-邮享权益-苏邮惠，实名注册会员。",
        //   position: "bottom",
        // });
      }
    });
  }

  protected registerSubmit() {
    if (!this.registerInfo.phone) {
      this.$toast("请输入手机号码");
      return;
    }
    if (!this.registerInfo.idno) {
      this.$toast("请输入身份证号码");
      return;
    }
    const reg = /^1\d{10}$/;
    if (!reg.test(this.registerInfo.phone)) {
      this.$toast("手机号格式不正确");
      return;
    }
    if (
      this.registerInfo.idno.length != 18 &&
      this.registerInfo.idno.length != 15
    ) {
      this.$toast("身份证号长度不正确");
      return;
    }
    if (!this.registerInfo.orgid) {
      this.$toast("请选择所属机构");
      return;
    }
    this.buttonActive = true;
    api
      .post("/weixinmp/xsyx/myuser/registerSubmit", this.registerInfo)
      .then((res: any) => {
        if (res.data.flag === "0") {
          Toast.success("注册成功");
          const interval = window.setInterval(() => {
            window.clearInterval(interval);
            this.$router.replace(
              "/main/kjsmch/getKjsmchCoupon/" + this.$route.params.activityid
            );
          }, 2000);
        } else if (res.data.flag === "1") {
          this.buttonActive = false;
          Toast.fail("您的微信已注册，请勿重复注册");
        } else if (res.data.flag === "2") {
          this.buttonActive = false;
          Toast.fail("身份证号已存在，请勿重复注册");
        } else if (res.data.flag === "3") {
          this.buttonActive = false;
          Toast.fail("手机号已存在，请勿重复注册");
        } else if (res.data.flag === "4") {
          this.buttonActive = false;
          Toast.fail("身份证号格式错误，请检查后重试");
        }
      });
  }

  protected onOrgConfirm(picker: any, index: any) {
    this.registerInfo.orgname =
      this.orgList[index[0]].children[index[1]].children[index[2]].text;
    this.registerInfo.orgid =
      this.orgList[index[0]].children[index[1]].children[index[2]].orgId;
    this.registerInfo.orgindex = index;
    this.showOrg = false;
  }

  protected toRegister() {
    this.$router.go(0);
  }

  protected toRaffle() {
    this.$router.replace(
      "/main/kjsmch/getKjsmchCoupon/" + this.$route.params.activityid
    );
  }
}
